(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3802"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3802"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRegister("hYHHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f45fec4375ed784b$export$2e2bcd8739ae039; });

var $61ynQ = parcelRequire("61ynQ");
class $f45fec4375ed784b$export$2e2bcd8739ae039 extends (0, $61ynQ.EventEmitter) {
    constructor({ $target: $target, initialState: initialState }){
        super();
        this.$target = $target;
        this.state = initialState;
        this.init();
        this.render();
    }
    /**
     * Component state change logic
     *
     * @param newState state value to change
     * @param preventRender If true, no rendering is done after the state is changed.
     * @param callback If set, called back if state has changed.
     */ setState(newState, preventRender, callback) {
        if (!this.checkNeedUpdate(newState)) return;
        if (this.state) this.state = {
            ...this.state,
            ...newState
        };
        else this.state = {
            ...newState
        };
        if (callback) {
            callback();
            return;
        }
        if (preventRender) return;
        this.render();
    }
    /**
     * Component state validation, basic... can use more advanced like fast-deep-equal package
     *
     * @param newState state value to validate
     */ checkNeedUpdate(newState) {
        const prevState = JSON.stringify({
            ...this.state
        });
        const currentState = JSON.stringify({
            ...this.state,
            ...newState
        });
        return prevState !== currentState;
    }
}

});
parcelRegister("61ynQ", function(module, exports) {

$parcel$export(module.exports, "EventEmitter", function () { return $990714a3f13c6c13$export$4fae95256245c8c0; });
class $990714a3f13c6c13$export$4fae95256245c8c0 {
    on(event, listener) {
        if (typeof this.events[event] !== "object") this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.off(event, listener);
    }
    off(event, listener) {
        if (typeof this.events[event] !== "object") return;
        this.events[event] = this.events[event].filter((eventListener)=>eventListener !== listener);
    }
    offAll() {
        Object.keys(this.events).forEach((event)=>this.events[event] = []);
    }
    emit(event, ...args) {
        if (typeof this.events[event] === "object") [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
        [
            ...this.events["*"]
        ].forEach((listener)=>listener.apply(this, [
                event,
                ...args
            ]));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
    constructor(){
        this.events = {
            "*": []
        };
    }
}

});


parcelRegister("lOhkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12af2113e899b28a$export$2e2bcd8739ae039; });
var $12af2113e899b28a$export$2e2bcd8739ae039 = {
    thematics: [
        {
            id: 1,
            title: "Outdoor",
            ref: "outdoor",
            description: "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces."
        },
        {
            id: 2,
            title: "Textiles",
            ref: "textile",
            description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
        },
        {
            id: 3,
            title: "Wallpaper Coverings",
            ref: "wallpaper",
            description: "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics."
        },
        {
            id: 4,
            title: "Bathroom Design",
            ref: "bathroom",
            description: "Highly innovative interiors: water sustainability according to Salotto NY."
        },
        {
            id: 5,
            title: "Contractor Kitchens",
            ref: "kitchen",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        }
    ]
};

});

parcelRegister("bRYHY", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", function () { return $294cf4e6b5dd2072$export$9a2147b3808d4c6b; });
$parcel$export(module.exports, "setUserLocale", function () { return $294cf4e6b5dd2072$export$e6103b0362967aab; });
$parcel$export(module.exports, "getLocale", function () { return $294cf4e6b5dd2072$export$180605366c04f0cd; });
$parcel$export(module.exports, "getLocaleLang", function () { return $294cf4e6b5dd2072$export$3814be8b8b1016be; });
$parcel$export(module.exports, "getLabel", function () { return $294cf4e6b5dd2072$export$236350842f3cd9bc; });

var $6LC72 = parcelRequire("6LC72");

var $3fspn = parcelRequire("3fspn");

var $4D7jm = parcelRequire("4D7jm");
const $294cf4e6b5dd2072$var$LOCALE_EN = "EN";
const $294cf4e6b5dd2072$var$DEFAULT_LOCALE = $294cf4e6b5dd2072$var$LOCALE_EN;
let $294cf4e6b5dd2072$var$USER_LOCALE;
const $294cf4e6b5dd2072$var$localeStorage = {};
const $294cf4e6b5dd2072$export$9a2147b3808d4c6b = function() {
    return $294cf4e6b5dd2072$var$DEFAULT_LOCALE;
}();
function $294cf4e6b5dd2072$var$registerLocale(locale, localeObj) {
    locale = locale.toUpperCase();
    $294cf4e6b5dd2072$var$localeStorage[locale] = localeObj;
}
function $294cf4e6b5dd2072$export$ddc371781a6af754(lang, localeObj) {
    if (lang) {
        const localeObj = $294cf4e6b5dd2072$var$localeStorage[lang.toUpperCase()] || {};
        if (lang === $294cf4e6b5dd2072$var$LOCALE_EN) return {
            ...localeObj
        };
        else return (0, $4D7jm.merge)({
            ...localeObj
        }, {
            ...$294cf4e6b5dd2072$var$localeStorage[$294cf4e6b5dd2072$var$DEFAULT_LOCALE]
        });
    } else return (0, $4D7jm.merge)({
        ...localeObj
    }, {
        ...$294cf4e6b5dd2072$var$localeStorage[$294cf4e6b5dd2072$var$DEFAULT_LOCALE]
    });
}
function $294cf4e6b5dd2072$export$e6103b0362967aab(lang) {
    if (lang) {
        console.log("Lang ", lang);
        $294cf4e6b5dd2072$var$USER_LOCALE = lang;
        const userLocale = $294cf4e6b5dd2072$export$ddc371781a6af754(lang);
        $294cf4e6b5dd2072$var$registerLocale(lang, userLocale);
    }
}
function $294cf4e6b5dd2072$export$180605366c04f0cd(lang) {
    if (lang) return $294cf4e6b5dd2072$var$localeStorage[lang];
    else if ($294cf4e6b5dd2072$var$USER_LOCALE) return $294cf4e6b5dd2072$var$localeStorage[$294cf4e6b5dd2072$var$USER_LOCALE];
    else return $294cf4e6b5dd2072$var$localeStorage[$294cf4e6b5dd2072$var$DEFAULT_LOCALE];
}
function $294cf4e6b5dd2072$export$3814be8b8b1016be() {
    return $294cf4e6b5dd2072$var$USER_LOCALE || $294cf4e6b5dd2072$var$DEFAULT_LOCALE;
}
function $294cf4e6b5dd2072$export$665560c9ff312dd4() {
    return (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
}
function $294cf4e6b5dd2072$export$236350842f3cd9bc(localeObj, key) {
    if (localeObj[key] !== undefined && typeof localeObj[key] === "string") return localeObj[key];
    else return key;
}
$294cf4e6b5dd2072$var$registerLocale($294cf4e6b5dd2072$var$LOCALE_EN, (0, $6LC72.default));
$294cf4e6b5dd2072$var$registerLocale("IT", (0, $3fspn.default));

});
parcelRegister("6LC72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01f219ad84599d5$export$2e2bcd8739ae039; });
/**
 * Language: English.
 */ var $c01f219ad84599d5$export$2e2bcd8739ae039 = {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1"
    },
    thematics: {
        "outdoor": "Outdoor",
        "textile": "Textiles",
        "wallpaper": "Wallpaper",
        "kitchen": "Contractor Kitchens",
        "bathroom": "Bathroom Design"
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY."
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    }
};

});

parcelRegister("3fspn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e73f3a0b7bd7434b$export$2e2bcd8739ae039; });
/**
 * Language: Italian.
 */ var $e73f3a0b7bd7434b$export$2e2bcd8739ae039 = {
    "messages": {
        "choose_thematic": "Scegli Tematica",
        "sessionReset": "La sessione si reimposter\xe0 automaticamente tra",
        "minute": "minuto",
        "resetMap": "Reimposta Mappa",
        "selectLanguage": "Seleziona una Lingua",
        "seconds": "secondi",
        "cta": {
            "switch_standard_view": "Passa alla visualizzazione standard"
        },
        "minutes": "minuti",
        "multilevelwarning": "Questo percorso \xe8 su due livelli e passa anche per il Quick Link a livello 1"
    },
    "thematics": {
        "outdoor": "Outdoor",
        "textile": "Tessile",
        "wallpaper": "Wallpaper",
        "kitchen": "Cucina Contract",
        "bathroom": "Progetto Bagno"
    },
    "thematicDescription": {
        "outdoor": "Design, durabilit\xe0 e comfort: evoluzione continua per arredare giardini, terrazzi e spazi di piccole dimensioni.",
        "textile": "Percorsi tessili che intrecciano tecnologie pi\xf9 avanzate e inconfondibile segno artigianale.",
        "wallpaper": "Soluzioni e ricerche tra materiali, pattern e colori che uniscono tecnica ed estetica.",
        "kitchen": "Progetti, arredi su misura e soluzioni per hotel, residence, uffici e retail.",
        "bathroom": "Arredi ad alto tasso di innovazione: la sostenibilit\xe0 idrica secondo Salotto NY."
    },
    "errors": {
        "loadingLibrary": "Impossibile caricare lo script {library}",
        "geolocationFailed": "Geolocalizzazione dell'utente fallita",
        "apiErrors": {
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore interno del server",
            "other": "Si \xe8 verificato un errore imprevisto del server"
        }
    }
};

});

parcelRegister("4D7jm", function(module, exports) {

$parcel$export(module.exports, "objectToQueryString", function () { return $fb47a354e391b3c4$export$89a7e74069fbb7af; });
$parcel$export(module.exports, "merge", function () { return $fb47a354e391b3c4$export$4950aa0f605343fb; });
$parcel$export(module.exports, "replace", function () { return $fb47a354e391b3c4$export$77ad94ebf1c2b9ed; });

var $lOhkc = parcelRequire("lOhkc");

var $bRYHY = parcelRequire("bRYHY");

var $cuvjN = parcelRequire("cuvjN");
function $fb47a354e391b3c4$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $fb47a354e391b3c4$export$b89605802fcf91d2(polylineString, precision = 5) {
    const coordinates = [];
    const factor = Math.pow(10, precision);
    let index, lat, lng, byte, shift, result, latitude_change, longitude_change;
    index = 0;
    lat = 0;
    lng = 0;
    while(index < polylineString.length){
        byte = null;
        shift = 0;
        result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        shift = result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
}
function $fb47a354e391b3c4$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $fb47a354e391b3c4$export$37827d046293d309(text) {
    const canvas = document.getElementById("canvasMarkerWoosmap") || document.createElement("canvas");
    canvas.id = "canvasMarkerWoosmap";
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.font = "bold 15px sans-serif";
    return context.measureText(text).width;
}
function $fb47a354e391b3c4$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input);
}
function $fb47a354e391b3c4$export$4950aa0f605343fb(target, source) {
    if (!$fb47a354e391b3c4$export$a6cdc56e425d0d0a(source) || !$fb47a354e391b3c4$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($fb47a354e391b3c4$export$a6cdc56e425d0d0a(sourceProp) && $fb47a354e391b3c4$export$a6cdc56e425d0d0a(targetProp)) $fb47a354e391b3c4$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $fb47a354e391b3c4$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), keyValues[key]);
    });
    return result;
}
function $fb47a354e391b3c4$export$f73bf9563a5df5ec(theme) {
    if (theme && (theme !== "sdm_default" || "")) {
        const jsonData = (0, $lOhkc.default)["thematics"];
        const filteredTheme = Array.from(jsonData).filter((element)=>{
            return element.ref.toLowerCase() === theme.toLowerCase();
        });
        if (filteredTheme[0]) filteredTheme[0] = {
            ...filteredTheme[0],
            title: (0, $bRYHY.getLabel)((0, $bRYHY.getLocale)().thematics, theme.toLowerCase()),
            description: (0, $bRYHY.getLabel)((0, $bRYHY.getLocale)().thematicDescription, theme.toLowerCase())
        };
        return filteredTheme[0];
    }
}
function $fb47a354e391b3c4$export$c6d77cdc3b11bbfd(pav) {
    if (pav && pav !== "") {
        const jsonData = (0, $cuvjN.default)["buildings"];
        const filteredResult = Array.from(jsonData).filter((element)=>{
            return element.ref.toLowerCase() === pav.toLowerCase();
        });
        return filteredResult[0];
    }
}

});
parcelRegister("cuvjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafa928d5b637631$export$2e2bcd8739ae039; });
var $cafa928d5b637631$export$2e2bcd8739ae039 = {
    buildings: [
        {
            ref: "pav1_3",
            title: "Pav 01-03",
            pavilion: [
                "pav1",
                "pav3"
            ],
            thematics: [
                "wallpaper",
                "outdoor",
                "textile"
            ],
            center: {
                lat: 45.517404547972504,
                lng: 9.0829660782425
            }
        },
        {
            ref: "pav2_4",
            title: "Pav 02-04",
            pavilion: [
                "pav2",
                "pav4"
            ],
            thematics: [
                "kitchen"
            ],
            center: {
                lat: 45.51977094554,
                lng: 9.084641596885
            }
        },
        {
            ref: "pav5_7",
            title: "Pav 05-07",
            pavilion: [
                "pav5",
                "pav7"
            ],
            thematics: [
                "wallpaper",
                "outdoor",
                "textile"
            ],
            center: {
                lat: 45.518486051029996,
                lng: 9.08057912806
            }
        },
        {
            ref: "pav6_10",
            title: "Pav 06-10",
            pavilion: [
                "pav6",
                "pav10"
            ],
            thematics: [
                "bathroom"
            ],
            center: {
                lat: 45.52043912007,
                lng: 9.081303605317501
            }
        },
        {
            ref: "pav9_11",
            title: "Pav 09-11",
            pavilion: [
                "pav9",
                "pav11"
            ],
            thematics: [
                "kitchen",
                "outdoor"
            ],
            center: {
                lat: 45.519864817035,
                lng: 9.075825940384998
            }
        },
        {
            ref: "pav13_15",
            title: "Pav 13-15",
            pavilion: [
                "pav13",
                "pav15"
            ],
            thematics: [
                "outdoor",
                "textile"
            ],
            center: {
                lat: 45.5207451646875,
                lng: 9.073293433275
            }
        },
        {
            ref: "pav14_18",
            title: "Pav 14-18",
            pavilion: [
                "pav14",
                "pav18"
            ],
            thematics: [
                "wallpaper",
                "outdoor",
                "textile"
            ],
            center: {
                lat: 45.5216703575,
                lng: 9.0777833391
            }
        },
        {
            ref: "pav22_24",
            title: "Pav 22-24",
            pavilion: [
                "pav22",
                "pav24"
            ],
            thematics: [
                "kitchen",
                "wallpaper",
                "outdoor",
                "textile"
            ],
            center: {
                lat: 45.52294009775724,
                lng: 9.074819554722694
            }
        }
    ]
};

});



parcelRegister("fBkiV", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("aopwU")).then(()=>parcelRequire("cXdhN"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("820dr", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3XIbI")).then(()=>parcelRequire("fe4rH"));

});

var $34b16ba23616d372$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("7dsHC"), JSON.parse('["7dsHC","index.3ee49196.js","aopwU","thematicSelector.c6df0327.js","3XIbI","kiosk.61c9f7cc.js","24quA","index.2a5cb3bc.css"]'));


var $hYHHH = parcelRequire("hYHHH");

var $hYHHH = parcelRequire("hYHHH");
var $8cea015755a40829$var$Urls;
(function(Urls) {
    Urls["mapJS"] = "https://sdk.woosmap.com/map/map.js";
    Urls["widgetJS"] = "https://sdk.woosmap.com/map/widgets.js";
})($8cea015755a40829$var$Urls || ($8cea015755a40829$var$Urls = {}));
var $8cea015755a40829$export$2e2bcd8739ae039 = $8cea015755a40829$var$Urls;



var $4D7jm = parcelRequire("4D7jm");

/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $3872ebb1e557a7b0$var$cachedScripts = {};
function $3872ebb1e557a7b0$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override, callback: callback } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $4D7jm.objectToQueryString)(params)}`;
    const existing = $3872ebb1e557a7b0$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $3872ebb1e557a7b0$var$getScriptElement(src);
            if (script) {
                delete $3872ebb1e557a7b0$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($3872ebb1e557a7b0$var$findScript(src)) resolve();
        const script = $3872ebb1e557a7b0$export$28503efd90ff36be(url, params);
        const dependencyScriptSrc = (0, $8cea015755a40829$export$2e2bcd8739ae039).widgetJS;
        const loadDependency = (dependencySrc)=>{
            return new Promise((dependencyResolve, dependencyReject)=>{
                const dependencyScript = $3872ebb1e557a7b0$export$28503efd90ff36be(dependencySrc);
                const onDependencyScriptLoad = ()=>{
                    dependencyScript.removeEventListener("load", onDependencyScriptLoad);
                    dependencyScript.removeEventListener("error", onDependencyScriptError);
                    dependencyResolve();
                };
                const onDependencyScriptError = ()=>{
                    cleanup();
                    delete $3872ebb1e557a7b0$var$cachedScripts[dependencySrc];
                    dependencyScript.remove();
                    const dependencyError = new Error(`The dependency script "${dependencySrc}" failed to load.`);
                    dependencyReject(dependencyError);
                };
                dependencyScript.addEventListener("load", onDependencyScriptLoad);
                dependencyScript.addEventListener("error", onDependencyScriptError);
                document.body.insertBefore(dependencyScript, document.body.lastElementChild);
            });
        };
        const onScriptLoad = ()=>{
            cleanup();
            loadDependency(dependencyScriptSrc).then(()=>{
                if (callback) callback(); // Execute the callback after script and dependencies have loaded
                resolve();
            }).catch((dependencyError)=>{
                reject(dependencyError);
            });
        };
        const onScriptError = ()=>{
            cleanup();
            delete $3872ebb1e557a7b0$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        document.body.insertBefore(script, document.body.lastElementChild);
        function cleanup() {
            script.removeEventListener("load", onScriptLoad);
            script.removeEventListener("error", onScriptError);
        }
    });
    $3872ebb1e557a7b0$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $3872ebb1e557a7b0$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $3872ebb1e557a7b0$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $3872ebb1e557a7b0$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $4D7jm.objectToQueryString)(params)}`;
    newScript.async = true;
    newScript.defer = true;
    return newScript;
}
function $3872ebb1e557a7b0$export$41a88579f6bd1282() {
    $3872ebb1e557a7b0$var$cachedScripts = {};
}



var $4D7jm = parcelRequire("4D7jm");

var $bRYHY = parcelRequire("bRYHY");
const $55da9cf6f9fa6804$var$woosmapPublicKey = "woos-a10037a3-3f08-311e-af1d-2eb8b922749a";
const $55da9cf6f9fa6804$var$libraries = "widgets";
const $55da9cf6f9fa6804$var$env = "prod";
const $55da9cf6f9fa6804$var$mapOptions = {
    center: {
        lat: 49,
        lng: 9
    },
    zoom: 18
};
const $55da9cf6f9fa6804$var$indoorRendererOptions = {
    centerMap: false,
    theme: "sdm_default",
    venue: $55da9cf6f9fa6804$var$env === "prod" ? "SDM_2024" : "SDM_2024_dev",
    forceExtrusion: false,
    useInfoWindow: true,
    directionsIcons: {
        destinationIcon: {
            url: "",
            scaledSize: {
                height: 0,
                width: 0
            }
        }
    }
};
const $55da9cf6f9fa6804$var$widgetOptions = {
    // autocompleteWithDistance: true,
    ui: {
        primaryColor: "rgb(0 0 0 / 80%)",
        secondaryColor: "#e30613"
    },
    autocomplete: {
        maxResponses: 10
    }
};
const $55da9cf6f9fa6804$var$GATag = $55da9cf6f9fa6804$var$env === "prod" ? "GTM-WJM8VDL2" : "GTM-MQ2P2JCK";
var $55da9cf6f9fa6804$export$2e2bcd8739ae039 = {
    mapOptions: $55da9cf6f9fa6804$var$mapOptions,
    indoorRendererOptions: $55da9cf6f9fa6804$var$indoorRendererOptions,
    indoorWidgetOptions: $55da9cf6f9fa6804$var$widgetOptions,
    woosmapPublicKey: $55da9cf6f9fa6804$var$woosmapPublicKey,
    libraries: $55da9cf6f9fa6804$var$libraries,
    query: "",
    GATag: $55da9cf6f9fa6804$var$GATag,
    env: $55da9cf6f9fa6804$var$env
};




var $4D7jm = parcelRequire("4D7jm");
const $2b097174136e3617$export$f84bd70098573c5c = {
    map: (0, $55da9cf6f9fa6804$export$2e2bcd8739ae039),
    urls: (0, $8cea015755a40829$export$2e2bcd8739ae039)
};
let $2b097174136e3617$var$currentConfig = $2b097174136e3617$export$f84bd70098573c5c;
function $2b097174136e3617$export$29b4b847eef7ae1e(configObj) {
    const config = configObj || {};
    return (0, $4D7jm.merge)({
        ...config
    }, {
        ...$2b097174136e3617$var$currentConfig
    });
}
function $2b097174136e3617$export$940a7873bb071df8(configObj) {
    $2b097174136e3617$var$currentConfig = $2b097174136e3617$export$29b4b847eef7ae1e(configObj);
}
function $2b097174136e3617$export$44487a86467333c3() {
    return $2b097174136e3617$var$currentConfig;
}


var $8177ac111393a43b$export$715fed9478e7c158;
(function(MapComponentEvents) {
    MapComponentEvents["MAP_READY"] = "map_ready";
    MapComponentEvents["MAP_IDLE"] = "idle";
    MapComponentEvents["INDOOR_VENUE_LOADED"] = "indoor_venue_loaded";
    MapComponentEvents["INDOOR_WIDGET_ANALYTICS"] = "indoor_widget_analytics";
    MapComponentEvents["INDOOR_POI_ON_MAP_CLICK"] = "indoor_feature_selected";
    MapComponentEvents["INDOOR_HIGHLIGHT_STEP"] = "indoor_highlight_step";
    MapComponentEvents["INDOOR_STOP_NAVIGATION"] = "indoor_stop_navigation";
})($8177ac111393a43b$export$715fed9478e7c158 || ($8177ac111393a43b$export$715fed9478e7c158 = {}));
class $8177ac111393a43b$export$2e2bcd8739ae039 extends (0, $hYHHH.default) {
    init() {
        this.$element = document.createElement("div");
        this.$element.id = "map";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $3872ebb1e557a7b0$export$2cb99e4be0dc4646)({
            url: (0, $8cea015755a40829$export$2e2bcd8739ae039).mapJS,
            params: {
                key: this.state.woosmapPublicKey,
                libraries: this.state.libraries,
                language: (0, $bRYHY.getLocaleLang)().toLowerCase()
            },
            override: true,
            callback: ()=>{
                this.initMapView();
            }
        }).then(()=>{
            // this.initMapView();
            console.log("Scripts loaded...");
        }).catch((error)=>{
            console.error((0, $4D7jm.replace)((0, $bRYHY.getLocale)().errors.loadingLibrary, {
                "library": "Woosmap Map JS SDK script"
            }), error);
        });
    }
    initMapView() {
        this.map = new woosmap.map.Map("map", Object.assign({}, this.state.mapOptions));
        this.emit("map_ready");
        this.map.addListener("idle", ()=>{
            this.emit("idle");
        });
        this.map.addListener("rightclick", (e)=>{
            console.log(e);
        });
    }
    initIndoorView() {
        const widgetOptions = this.state.query && this.state.query !== `thematic:=${(0, $2b097174136e3617$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorWidgetOptions,
            baseFilter: this.state.query
        } : this.state.indoorWidgetOptions;
        const rendererOptions = this.state.query && this.state.query !== `thematic:=${(0, $2b097174136e3617$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorRendererOptions,
            baseFilter: this.state.query
        } : this.state.indoorRendererOptions;
        this.indoorMap = new woosmap.map.IndoorWidget(widgetOptions, rendererOptions);
        this.indoorMap.setMap(this.map);
        this.indoorMap.addListener("indoor_venue_loaded", (venue)=>{
            this.emit("indoor_venue_loaded", venue);
        });
        this.indoorMap.addListener("indoor_widget_analytics", (event)=>{
            this.emit("indoor_widget_analytics", event);
        });
        this.indoorMap.addListener("indoor_feature_selected", (event)=>{
            this.emit("indoor_feature_selected", event);
        });
        this.indoorMap.addListener("indoor_highlight_step", (event)=>{
            this.emit("indoor_highlight_step", event);
        });
        this.indoorMap.addListener("indoor_stop_navigation", (event)=>{
            this.emit("indoor_stop_navigation", event);
        });
    }
    setFilter(filter) {
        const filterToApply = filter !== undefined ? `thematic:=${filter} OR ${filter}:=true` : ``;
        if (filter !== "sdm_default") {
            this.indoorMap.getRenderer().setBaseFilter(filterToApply);
            this.indoorMap.setBaseFilter(filterToApply);
        }
    }
    setOrigin(data) {
        this.indoorMap.setUserLocation(data.lat, data.lng, data.level || 0, 0, true);
    }
    setTheme(theme) {
        const themeToApply = theme !== undefined ? theme : "sdm_default";
        this.indoorMap.setTheme(themeToApply);
    }
    setBounds(bounds) {
        let padding = {
            top: 0,
            left: 150,
            right: 150,
            bottom: 0
        };
        if (this.$element.clientWidth > 768) padding = {
            top: 350,
            left: 350,
            right: 350,
            bottom: 350
        };
        this.map.fitBounds(bounds, padding, true);
    }
    unselectPOI() {
        this.indoorMap.unselectFeature();
    }
    turnOffNavigation() {
        this.indoorMap.setNavigationMode(false);
    }
    getDirections() {
        return this.indoorMap.getRenderer()._directionsRenderer.directions;
    }
}




var $bRYHY = parcelRequire("bRYHY");

var $4D7jm = parcelRequire("4D7jm");
/**
 * Previously preloaded links that have been requested by `preloadLink()`.
 */ let $cf8df6cda61b96c0$var$preloadedLinks = {};
function $cf8df6cda61b96c0$export$a0db4953bb08f589(options) {
    const { url: url, params: params, as: as, crossOrigin: crossOrigin, override: override } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $4D7jm.objectToQueryString)(params)}`;
    const existing = $cf8df6cda61b96c0$var$preloadedLinks[src];
    if (existing) {
        if (override) {
            const link = $cf8df6cda61b96c0$var$getLinkElement(src);
            if (link) {
                delete $cf8df6cda61b96c0$var$preloadedLinks[src];
                link.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($cf8df6cda61b96c0$var$findLink(src)) resolve();
        const link = $cf8df6cda61b96c0$export$b756667c7b6cccbc(url, params, as, crossOrigin);
        const onLinkLoad = ()=>{
            resolve();
        };
        const onLinkError = ()=>{
            cleanup();
            delete $cf8df6cda61b96c0$var$preloadedLinks[src];
            link.remove();
            const defaultError = new Error(`The link "${src}" failed to preload.`);
            reject(defaultError);
        };
        link.addEventListener("load", onLinkLoad);
        link.addEventListener("error", onLinkError);
        document.head.insertBefore(link, document.head.firstElementChild);
        function cleanup() {
            link.removeEventListener("load", onLinkLoad);
            link.removeEventListener("error", onLinkError);
        }
    });
    $cf8df6cda61b96c0$var$preloadedLinks[src] = promise;
    return promise;
}
/**
 * Find link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {boolean | null} returns `true` if link exist otherwise `null`.
 */ function $cf8df6cda61b96c0$var$findLink(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return true;
}
/**
 * Get link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {HTMLLinkElement | null} returns existing `HTMLLinkElement` if link exist otherwise `null`.
 */ function $cf8df6cda61b96c0$var$getLinkElement(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return currentLink;
}
function $cf8df6cda61b96c0$export$b756667c7b6cccbc(url, params = {}, as, crossOrigin, type) {
    const newLink = document.createElement("link");
    if (Object.keys(params).length) newLink.href = `${url}?${(0, $4D7jm.objectToQueryString)(params)}`;
    else newLink.href = `${url}`;
    if (crossOrigin) newLink.crossOrigin = crossOrigin;
    if (type) newLink.type = type;
    newLink.rel = "preload";
    newLink.as = as;
    return newLink;
}
function $cf8df6cda61b96c0$export$f427c08ae26d1d06() {
    $cf8df6cda61b96c0$var$preloadedLinks = {};
}



var $ba5329b17b596e0d$export$54f5f69c1651567f;
(function(WidgetEvents) {
    WidgetEvents["AUTOCOMPLETE"] = "AUTOCOMPLETE";
    WidgetEvents["POI_SELECTED"] = "POI_SELECTED";
    WidgetEvents["PHONE_CLICKED"] = "PHONE_CLICKED";
    WidgetEvents["WEBSITE_CLICKED"] = "WEBSITE_CLICKED";
    WidgetEvents["SEARCH_RESULT_ITEM_SELECTED"] = "SEARCH_RESULT_ITEM_SELECTED";
    WidgetEvents["FIND_ROUTE"] = "FIND_ROUTE";
    WidgetEvents["NAVIGATION_STARTED"] = "NAVIGATION_STARTED";
})($ba5329b17b596e0d$export$54f5f69c1651567f || ($ba5329b17b596e0d$export$54f5f69c1651567f = {}));
var $ba5329b17b596e0d$export$6955bcca4cd3539f;
(function(Page) {
    Page["EXHIBITORS"] = "exhibitors";
    Page["THEMATIC"] = "thematic";
    Page["KIOSK"] = "kiosk";
})($ba5329b17b596e0d$export$6955bcca4cd3539f || ($ba5329b17b596e0d$export$6955bcca4cd3539f = {}));



class $ba5329b17b596e0d$export$2e2bcd8739ae039 extends (0, $hYHHH.default) {
    init() {}
    render() {
        (0, $bRYHY.setUserLocale)(this.state.locale || (0, $bRYHY.SYSTEM_LANG));
        (0, $2b097174136e3617$export$940a7873bb071df8)(this.state.config);
        this.preloadLinks();
        this.mapComponent = new (0, $8177ac111393a43b$export$2e2bcd8739ae039)({
            $target: document.getElementById("app"),
            initialState: {
                woosmapPublicKey: (0, $2b097174136e3617$export$44487a86467333c3)().map.woosmapPublicKey,
                mapOptions: (0, $2b097174136e3617$export$44487a86467333c3)().map.mapOptions,
                indoorRendererOptions: (0, $2b097174136e3617$export$44487a86467333c3)().map.indoorRendererOptions,
                indoorWidgetOptions: (0, $2b097174136e3617$export$44487a86467333c3)().map.indoorWidgetOptions,
                libraries: (0, $2b097174136e3617$export$44487a86467333c3)().map.libraries,
                query: this.state.config?.map.query
            }
        });
        this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).MAP_READY, ()=>{
            this.mapComponent.initIndoorView();
            this.loadGoogleTagManager();
        });
        this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).MAP_IDLE, ()=>{
        // if(this.mapComponent.map.getZoom() < 16){
        //     this.mapComponent.map.setZoom(16);
        // }
        });
        this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_VENUE_LOADED, (venue)=>{
            console.log("Venue loaded ", venue);
            this.venue = venue;
            // Do any actions here when indoor venue is fully loaded
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.fetchKiosksData().then((kiosks)=>{
                    const queryParam = this.state.query?.split("=");
                    if (queryParam && queryParam.length > 0 && kiosks) {
                        const filteredKiosk = kiosks?.find((item)=>item.title.toLowerCase() === queryParam[1].toLowerCase());
                        this.isKiosk = true;
                        this.currentKiosk = filteredKiosk;
                        this.mapComponent.setOrigin(filteredKiosk);
                    }
                }).catch((error)=>{
                    console.error("Error in reading kiosk data", error);
                });
                this.mapComponent.turnOffNavigation();
            }
            if (this.state.query && this.state.query !== "" && this.state.query.includes("thematic")) {
                const selectedTheme = this.state.query.split("=")[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                this.mapComponent.setFilter(selectedTheme);
                window.dataLayer = window.dataLayer || [];
                if (this.selectedThematic && this.selectedThematic !== "sdm_default") this.getPOIExtendedData(undefined, this.state.query).then((pois)=>{
                    window.dataLayer = window.dataLayer || [];
                    this.itemsForThematicSelected = pois;
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "thematic",
                        content_id: this.selectedThematic,
                        parent_content_type: undefined,
                        parent_content_id: undefined,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined
                    });
                }).catch((error)=>{
                    console.error("Error while searching POIs:", error);
                });
                this.createResetMapElemnt();
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_WIDGET_ANALYTICS, (event)=>{
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.currentPage = "kiosk";
                this.kioskComponent.startSessionCountdown();
            }
            if (event.event === "AUTOCOMPLETE" && event.args.query.length >= 3) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_search",
                    search_term: event.args.query,
                    items: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
                const searchResults = event.args.results;
                const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                if (this.selectedThematic && this.selectedThematic !== "" && this.selectedThematic !== "sdm_default") {
                    const pois = this.createPOIListForAnalytics(searchResults, this.selectedThematic);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "woo_poi_search_list",
                        content_type: thematic,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        content_id: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined
                    });
                } else /* As far as possible avoid calling /search endpoint */ if (searchResults && searchResults.length > 0) {
                    // const refs: string = searchResults.map((element: SearchResult) => `ref:${element.ref}`).join(',');
                    const ids = searchResults.map((element)=>element.id).join(",");
                    this.getPOIExtendedData(ids).then((pois)=>{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "woo_poi_search_list",
                            content_type: thematic,
                            items: pois,
                            _clear: true,
                            search_term: undefined,
                            content_id: undefined,
                            item_name: undefined,
                            nav_from: undefined,
                            nav_to: undefined,
                            parent_content_type: undefined,
                            parent_content_id: undefined
                        });
                    }).catch((error)=>{
                        console.error("Error while searching POIs:", error);
                    });
                }
            }
            if (event.event === "SEARCH_RESULT_ITEM_SELECTED") {
                const poi = event.args;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_poi_search_clic",
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "FIND_ROUTE") {
                if (this.currentPage === "thematic") this.mapComponent.map.setHeading(26.39);
                // Comment this if something goes wrong in multi level warning changes !!!
                if (this.currentPage === "kiosk") this.checkForMultilevelDirections();
                const poi = event.args;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_clic_iti",
                    content_type: poi.destination.properties["thematic"] ? poi.destination.properties["thematic"] : "",
                    content_id: poi.destination.properties["POI_ID"],
                    item_name: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "NAVIGATION_STARTED") {
                const poi = event.args;
                let origin = poi.origin.properties["name"];
                if (poi.origin.id === -1) origin = this.isKiosk && this.currentKiosk ? `Kiosk ${this.currentKiosk.title}` : poi.origin.properties["name"];
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_nav",
                    nav_from: origin,
                    nav_to: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    item_name: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
        });
        this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_POI_ON_MAP_CLICK, (poi)=>{
            if (poi) window.dataLayer.push({
                event: "woo_poi_map_clic",
                content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                content_id: poi.properties["POI_ID"],
                item_name: poi.properties["name"],
                items: undefined,
                search_term: undefined,
                nav_from: undefined,
                nav_to: undefined
            });
        });
        if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) (parcelRequire("fBkiV")).then(({ default: ThematicComponent, ThematicComponentEvents: ThematicComponentEvents })=>{
            this.kioskComponent = new ThematicComponent({
                $target: document.getElementById("slider"),
                initialState: {
                    query: this.state.query
                }
            });
            this.currentPage = "kiosk";
            this.itemsForThematicSelected = [];
            this.kioskComponent.on(ThematicComponentEvents.THEMATIC_SELECTED, (thematic)=>{
                const selectedTheme = thematic.split("=")[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                this.mapComponent.setFilter(selectedTheme);
                this.mapComponent.setTheme(selectedTheme);
                this.mapComponent.unselectPOI();
                const center = new woosmap.map.LatLng(this.currentKiosk.lat, this.currentKiosk.lng);
                if (this.mapComponent.map.getCenter() !== center) this.mapComponent.setOrigin(this.currentKiosk);
                if (this.selectedThematic && this.selectedThematic !== "sdm_default") this.getPOIExtendedData(undefined, thematic).then((pois)=>{
                    this.itemsForThematicSelected = pois;
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "thematic",
                        content_id: this.selectedThematic,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined
                    });
                }).catch((error)=>{
                    console.error("Error while searching POIs:", error);
                });
            });
            this.kioskComponent.on(ThematicComponentEvents.LANGUAGE_CHANGED, (lang)=>{
                this.setState({
                    locale: lang
                });
            });
            this.kioskComponent.on(ThematicComponentEvents.BUILDING_SELECTED, (buildingList)=>{
                if (buildingList) {
                    if (buildingList && buildingList.ref && buildingList.ref === "pav2_4") {
                        console.log("Hardwired fixed for wrong bounds");
                        this.mapComponent.map.flyTo({
                            center: buildingList.center
                        });
                    } else this.computeBoundsOfBuildingSelected(buildingList);
                    const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "pav",
                        content_id: buildingList.title,
                        parent_content_type: "thematic",
                        parent_content_id: thematic,
                        items: this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined
                    });
                } else this.resetMap();
            });
            this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_HIGHLIGHT_STEP, (response)=>{
                const coordinates = response.feature.geometry.coordinates;
                const moveTo = coordinates[0];
                const position = {
                    lat: moveTo[1],
                    lng: moveTo[0],
                    level: response.feature.properties.floor || 0
                };
                this.mapComponent.setOrigin(position);
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_STOP_NAVIGATION, (response)=>{
                if (this.currentKiosk) {
                    this.mapComponent.setOrigin(this.currentKiosk);
                    this.resetMap();
                }
            });
        }).catch((error)=>{
            console.error("Dynamic kiosk component import failed:", error);
        });
        if (this.state.query && this.state.query !== "" && this.state.query.includes("thematic")) (parcelRequire("fBkiV")).then(({ default: ThematicComponent, ThematicComponentEvents: ThematicComponentEvents })=>{
            this.thematicComponent = new ThematicComponent({
                $target: document.getElementById("slider"),
                initialState: {
                    query: this.state.query,
                    showDescription: true
                }
            });
            this.currentPage = "thematic";
            this.thematicComponent.on(ThematicComponentEvents.THEMATIC_SELECTED, (thematic)=>{
                const selectedTheme = thematic.split("=")[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                this.mapComponent.setFilter(selectedTheme);
                this.mapComponent.setTheme(selectedTheme);
                this.mapComponent.unselectPOI();
                const initialCenter = (0, $2b097174136e3617$export$44487a86467333c3)().map.mapOptions.center;
                if (this.mapComponent.map.getCenter() !== initialCenter) {
                    this.mapComponent.map.panTo(this.thematicCenter);
                    setTimeout(()=>{
                        this.mapComponent.map.setZoom(17);
                    }, 500);
                }
                if (this.selectedThematic && this.selectedThematic !== "sdm_default") this.getPOIExtendedData(undefined, thematic).then((pois)=>{
                    window.dataLayer = window.dataLayer || [];
                    this.itemsForThematicSelected = pois;
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "thematic",
                        content_id: this.selectedThematic,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined
                    });
                }).catch((error)=>{
                    console.error("Error while searching POIs:", error);
                });
            });
            this.thematicComponent.on(ThematicComponentEvents.BUILDING_SELECTED, (buildingList)=>{
                if (buildingList) {
                    this.computeBoundsOfBuildingSelected(buildingList);
                    const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "pav",
                        content_id: buildingList.title,
                        parent_content_type: "thematic",
                        parent_content_id: thematic,
                        items: this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined
                    });
                } else this.resetMap();
            });
            this.mapComponent.on((0, $8177ac111393a43b$export$715fed9478e7c158).INDOOR_STOP_NAVIGATION, ()=>{
                this.resetMap();
            });
        }).catch((error)=>{
            console.error("Dynamic thematic selector component import failed:", error);
        });
    }
    async fetchKiosksData() {
        try {
            const kioskModule = await (parcelRequire("820dr"));
            const kioskData = kioskModule.default;
            return kioskData.kiosks;
        } catch (error) {
            console.error("Error importing Kiosk JSON file:", error);
        }
    }
    preloadLinks() {
        Promise.all([
            (0, $cf8df6cda61b96c0$export$a0db4953bb08f589)({
                url: (0, $2b097174136e3617$export$44487a86467333c3)().urls.mapJS,
                params: {
                    key: (0, $2b097174136e3617$export$44487a86467333c3)().map.woosmapPublicKey,
                    language: (0, $bRYHY.getLocaleLang)().toLowerCase(),
                    libraries: (0, $2b097174136e3617$export$44487a86467333c3)().map.libraries
                },
                as: "script"
            }),
            (0, $cf8df6cda61b96c0$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/tiles.json",
                params: {
                    key: (0, $2b097174136e3617$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $cf8df6cda61b96c0$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/style/streets.json",
                params: {
                    language: (0, $bRYHY.getLocaleLang)().toLowerCase(),
                    key: (0, $2b097174136e3617$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $cf8df6cda61b96c0$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.png",
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $cf8df6cda61b96c0$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.json",
                as: "fetch",
                crossOrigin: "anonymous"
            })
        ]);
    }
    createResetMapElemnt() {
        const $mapContainer = document.getElementById("map");
        const $btnToggle = document.getElementById("btnSwitchStandardView");
        if ($mapContainer && !$btnToggle) {
            const toggleStandardView = document.createElement("button");
            toggleStandardView.id = "btnSwitchStandardView";
            toggleStandardView.classList.add("toggle-standard-view");
            toggleStandardView.innerText = (0, $bRYHY.getLocale)().messages.cta["switch_standard_view"];
            toggleStandardView.addEventListener("click", ()=>{
                // location.reload();
                window.location.href = window.location.origin + window.location.pathname;
            });
            $mapContainer.appendChild(toggleStandardView);
        }
    }
    applyTheme(theme) {
        const { config: config } = this.state;
        if (config) {
            const mapConfig = config.map;
            const updatedMapOptions = {
                ...mapConfig,
                indoorRendererOptions: {
                    theme: theme,
                    baseFilter: `thematic:=${theme} OR ${theme}:=true`
                },
                indoorWidgetOptions: {
                    baseFilter: `thematic:=${theme} OR ${theme}:=true`
                }
            };
            const updatedConfig = {
                ...config,
                map: updatedMapOptions
            };
            this.setState({
                config: updatedConfig
            });
        }
    }
    getPOIExtendedData(ids, filter) {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            const arrPOIs = [];
            const callback = (featuresCollection)=>{
                if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) {
                    featuresCollection.features.forEach((element)=>{
                        const properties = element.properties;
                        const searchedPOI = {
                            item_id: properties["ref"],
                            item_name: properties["name"],
                            item_category: properties["thematic"],
                            quantity: 1
                        };
                        arrPOIs.push(searchedPOI);
                    });
                    resolve(arrPOIs);
                } else reject(new Error("No features found."));
            };
            indoorService.search(this.venue.venue_id, "", callback, null, ids, filter);
        });
    }
    createPOIListForAnalytics(results, thematic) {
        const arrPOIs = [];
        results.forEach((element)=>{
            const searchedPOI = {
                item_id: element.ref,
                item_name: element.name,
                item_category: thematic,
                quantity: 1
            };
            arrPOIs.push(searchedPOI);
        });
        return arrPOIs;
    }
    loadGoogleTagManager() {
        console.log("Google Tag Manager ", (0, $2b097174136e3617$export$44487a86467333c3)().map.GATag);
        const gaTrackingId = (0, $2b097174136e3617$export$44487a86467333c3)().map.GATag;
        if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}"]`)) (function(w, d, s, l, i) {
            w.dataLayer = w.dataLayer || [];
            w.dataLayer.push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l !== "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gaTrackingId);
    }
    computeBoundsOfBuildingSelected(buildingList) {
        if (buildingList["pavilion"]) {
            const mergedBounds = new woosmap.map.LatLngBounds();
            buildingList["pavilion"].forEach((item)=>{
                if (this.venue && this.venue.buildings && this.venue.buildings.length > 0) {
                    const filteredBuilding = this.venue.buildings.filter((building)=>building.ref === item)[0];
                    if (filteredBuilding && filteredBuilding.levels.length > 0) {
                        const bbox = filteredBuilding.levels.filter((level)=>level.level === 0)[0].bbox;
                        const bounds = new woosmap.map.LatLngBounds({
                            lng: bbox[0],
                            lat: bbox[1]
                        }, {
                            lng: bbox[2],
                            lat: bbox[3]
                        });
                        const position = {
                            lat: bounds.getCenter().lat(),
                            lng: bounds.getCenter().lng()
                        };
                        mergedBounds.extend(position);
                    }
                }
            });
            const newPosition = {
                lat: mergedBounds.getCenter().lat(),
                lng: mergedBounds.getCenter().lng()
            };
            this.mapComponent.map.flyTo({
                center: newPosition
            });
        }
    }
    resetMap() {
        const defaultOptions = {
            bearing: 26.39,
            animate: true,
            duration: 500
        };
        let mergedOptions;
        let zoom = 17;
        if (this.currentPage === "thematic") {
            mergedOptions = {
                ...defaultOptions,
                center: this.thematicCenter,
                zoom: 17
            };
            zoom = 17;
        } else if (this.currentPage === "kiosk") {
            if (this.currentKiosk) {
                mergedOptions = {
                    ...defaultOptions,
                    center: {
                        lat: this.currentKiosk.lat,
                        lng: this.currentKiosk.lng
                    },
                    zoom: 18,
                    pitch: 45
                };
                zoom = 18;
            }
        }
        if (mergedOptions && zoom) {
            this.mapComponent.map.flyTo(mergedOptions);
            setTimeout(()=>{
                this.mapComponent.map.setZoom(zoom);
            }, 550);
        }
    }
    showMultiLevelWarning() {
        const $mapElement = document.querySelector(".mapboxgl-control-container");
        if ($mapElement) {
            const $infoContainer = document.createElement("div");
            $infoContainer.classList.add("mapboxgl-ctrl-top-center", "fade-in-out");
            setTimeout(()=>{
                $infoContainer.classList.add("show");
            }, 200);
            const $info = document.createElement("div");
            $info.id = "map-info";
            $info.innerHTML = (0, $bRYHY.getLocale)().messages.multilevelwarning;
            $infoContainer.appendChild($info);
            $mapElement.appendChild($infoContainer);
            setTimeout(()=>{
                $infoContainer.classList.remove("show");
            }, 10000);
        }
    }
    groupInstructionsByLevel(steps) {
        const instructionsByLevel = [];
        let lastStepsByLevel = {
            level: null,
            steps: []
        };
        steps.forEach((step)=>{
            if (lastStepsByLevel.level !== step.properties.level) {
                lastStepsByLevel = {
                    level: step.properties.level,
                    steps: []
                };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    checkForMultilevelDirections() {
        const directionsResult = this.mapComponent.getDirections();
        if (directionsResult && directionsResult.routes && directionsResult.routes.length > 0) {
            const route = directionsResult.routes[0];
            const routeSteps = [];
            if (route.legs && route.legs.length > 0) {
                route.legs.forEach((leg)=>{
                    if (leg && leg.steps) leg.steps.forEach((step)=>{
                        const feature = {
                            type: "Feature",
                            properties: {
                                id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                level: `Level ${step.start_location.level}`,
                                floor: step.start_location.level,
                                instruction: step.instruction ? step.instruction.summary : null,
                                icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : "caret-down"
                            },
                            geometry: {
                                type: "LineString",
                                coordinates: step.polyline
                            }
                        };
                        routeSteps.push(feature);
                    });
                });
                if (routeSteps.length > 0) {
                    const levelsGroup = this.groupInstructionsByLevel(routeSteps);
                    if (levelsGroup.length > 2) this.showMultiLevelWarning();
                }
            }
        }
    }
    constructor(...args){
        super(...args);
        this.isKiosk = false;
        this.currentPage = "exhibitors";
        this.thematicCenter = {
            lat: 45.520419660861506,
            lng: 9.07898183369258
        };
    }
}


window.woosmapIndoorWidget = (0, $ba5329b17b596e0d$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=index.3ee49196.js.map
